import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Table, ConfigProvider, Button, Space, Tag, Modal, Typography, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { hnrequest } from '@/utils'

import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';

const { Paragraph } = Typography;
const Dbqq = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();
  const [bangm, setbangm] = useState([]);
  const [open, setOpen] = useState(false);
  const [ticks, setticks] = useState([]);


  useEffect(() => {
    async function getau() {
      const res = await hnrequest.post('/pqq_list')
      setbangm(res.rescode)
    }
    getau()
  }, [ticks])


  const goqq = () => {

    setOpen(true)



  }

  const onFxfsq = async (e) => {
    const rq = await hnrequest.post('/pqqsq', e)
    setOpen(false)
    setticks(rq.ticks)
    messageApi.open({ type: rq.return_code, content: rq.return_msg, });
  }






  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`检索内容`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            检索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });




  const columns = [

    {
      title: <Button
        onClick={() => goqq()}
      >强取申请</Button>,
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: '数据批次',
      key: 'dbno',
      ...getColumnSearchProps('dbno'),
      dataIndex: 'dbno',
      sorter: (a, b) => a.key - b.key,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: '申请日期',
      key: 'stime',
      ...getColumnSearchProps('stime'),
      dataIndex: 'stime',
      sorter: (a, b) => a.key - b.key,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: '状态',
      key: 'zt',
      render: (_, record) => (<Tag color={record.eh}>{record.zt}</Tag>),
    },

  ];


  return (
    <>

      <ConfigProvider locale={zhCN} >
        {contextHolder}
        <div >
          <Form form={form} component={false}>

            <Table
              // rowSelection={   {type:"checkbox",...rowSelection,}} 
              columns={columns} dataSource={bangm} />

          </Form>


          <Modal
            // title="数据修复申请表"
            footer={null}
            centered
            open={open}
            onOk={() => onFxfsq()}
            onCancel={() => setOpen(false)}
            width={{
              xs: '90%',
              sm: '80%',
              md: '70%',
              lg: '60%',
              xl: '50%',
              xxl: '40%',
            }}
          >
            <Paragraph type="danger">一、必须在公司认证周期内发起申请。 </Paragraph>
            <Paragraph type="danger">二、认证主体必须与追溯数据一致。 </Paragraph>
            <Paragraph type="danger">三、强取成功会将该产品下所有数据转移至本账号，非包年用户需另外对数据进行续费，包年用户有效期同包年周期。 </Paragraph>
            <Paragraph type="danger">四、申请强取数据费用为100元/批次，会因上述第二条导致申请失败；当前主体账号下数据无需申请。 </Paragraph>

            <Form
              name="dbxfsq"
              layout="horizontal"
              onFinish={onFxfsq}
              form={form}
            >
              <Form.Item name='dbno' label="数据批号" rules={[{ required: true, message: '请填写正确的数据批号！' },]}  >
                <Input />
              </Form.Item>
              <Form.Item>
                <Button type="primary"
                  htmlType="submit"
                  block={true} >
                  发   起   审  请
                </Button>
              </Form.Item>


            </Form>
          </Modal>







        </div>






      </ConfigProvider>
    </>

  );
};
export default Dbqq;